var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  }, [_c('navbar'), _vm._v(" "), _vm._m(0)], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-container"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "examples"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/about_1.jpg")
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/about_2.jpg")
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/about_3.jpg")
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/about_4.jpg")
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/about_5.jpg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "about-text"
  }, [_c('div', [_vm._v("\n          I create both functional and one of a kind sculptural ceramic work.\n        ")]), _vm._v(" "), _c('div', [_vm._v("\n          In my functional work my intent is to create pots that are not only functional\n          but also invite the user to touch and use these pieces.\n        ")]), _vm._v(" "), _c('div', [_vm._v("\n          I frequently manipulate the surface of a piece when it is still wet to capture\n          a moment in the life of the clay and to alter and enhance the form both visually and\n          functionally.\n        ")]), _vm._v(" "), _c('div', [_vm._v("\n          My work is inspired by nature, primarily the colors of the sea, sky, sand and\n          soft light that is frequent on the island of Martha’s Vineyard,  and influences by Cynthia\n          Bringle and Warren Mckenzie with whom I have studied.\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "footer"
  })])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d3af938a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/About.vue
// module id = qA7t
// module chunks = 1